import CloseIcon from '@mui/icons-material/Close'
import { Alert, AlertProps, Collapse, IconButton, SxProps, Typography } from '@mui/material'
import { styled } from '@mui/system'
import React, { useState } from 'react'

const CustomAlert = styled(Alert)(({ theme, variant }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  padding: theme.spacing(1.5),
  letterSpacing: '-0.14px',
  border: '1px solid',
  borderRadius: '8px',
  // TODO add styling for each type of alert
  '&.warning': {
    color: theme.palette.warning[700],
    backgroundColor: theme.palette.warning[25],
    borderColor: theme.palette.warning[300],
  },
  '&.success': {
    color: theme.palette.success[800],
    backgroundColor: theme.palette.success[25],
    borderColor: theme.palette.success[300],
  },
  '&.error': {
    color: theme.palette.error[700],
    backgroundColor: theme.palette.error[25],
    borderColor: theme.palette.error[300],
    '.MuiAlert-icon svg': {
      fill: theme.palette.error[600],
    },
  },
  '&.info': {
    color: theme.palette.primary[600],
    backgroundColor: theme.palette.primary[25],
    borderColor: variant === 'outlined' ? theme.palette.primary[100] : 'transparent',
    '.MuiAlert-icon svg': {
      fill: theme.palette.primary[600],
    },
    '& span': {
      fontWeight: 500,
      color: 'primary.700',
    },
  },

  '& .MuiAlert-icon svg': {
    width: '24px',
    height: '24px',
    padding: 0,
  },
  '& .MuiAlert-icon': {
    padding: 0,
  },
  '& .MuiAlert-message': {
    marginRight: theme.spacing(1.25),
    padding: 0,
  },
  '& .MuiAlert-action': {
    marginRight: 0,
    padding: 0,
    '& button': {
      padding: 0,
    },
  },
}))

interface IProps extends AlertProps {
  actionDescription?: string
  severity: any
  className?: string
  description: string | React.ReactNode
  withCloseButton?: boolean
  isIcon?: boolean
  sx?: SxProps
  onClose?: () => void
  variant?: 'filled' | 'standard' | 'outlined'
}

export default function (props: IProps) {
  const { actionDescription, severity, className, description, withCloseButton, isIcon, sx, onClose, variant } = props

  const [openAlert, setOpenAlert] = useState<boolean>(true)

  return (
    <>
      {withCloseButton ? (
        <Collapse in={openAlert}>
          <CustomAlert
            severity={severity}
            className={className}
            icon={isIcon}
            variant={variant}
            action={
              <IconButton
                aria-label="close alert"
                color="inherit"
                onClick={() => {
                  setOpenAlert(false)
                  if (onClose) {
                    onClose()
                  }
                }}
              >
                <CloseIcon sx={{ width: '18px', height: '18px' }} />
              </IconButton>
            }
            sx={{
              ...sx,
            }}
          >
            {description}
          </CustomAlert>
        </Collapse>
      ) : (
        <CustomAlert
          severity={severity}
          className={className}
          icon={isIcon}
          variant={variant}
          sx={{
            ...sx,
          }}
        >
          <Typography variant="body2">{description}</Typography>

          {actionDescription && (
            <Typography variant="body2" color="error.700" ml={2.5} sx={{ fontWeight: 500, letterSpacing: '-0.14px' }}>
              {actionDescription}
            </Typography>
          )}
        </CustomAlert>
      )}
    </>
  )
}
